import { render, staticRenderFns } from "./GoodsReturnManage.vue?vue&type=template&id=0cd13e08&"
import script from "./GoodsReturnManage.vue?vue&type=script&lang=js&"
export * from "./GoodsReturnManage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReturnManage.vue?vue&type=style&index=0&id=0cd13e08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports